import { DATE_FORMAT_STYLES, DURATION_FORMAT_STYLES, isAllowedFormatStyle } from '../formatAllowlists';
import { isBindMapRef, isBindRef } from './isBoundValue';
import { resolvePath } from './resolvePath';
function resolveBindMapTimezone(valuePath, keyPath, namespaces, loopItem) {
  const base = resolvePath(valuePath, namespaces, loopItem);
  if (base === null || typeof base !== 'object') return undefined;
  const key = resolvePath(keyPath, namespaces, loopItem);
  if (key === undefined || key === null) return undefined;
  const stringKey = String(key);
  return Object.prototype.hasOwnProperty.call(base, stringKey) ? base[stringKey] : undefined;
}
function resolveTimezone(timezone, namespaces, loopItem) {
  if (timezone === undefined) return undefined;
  if (typeof timezone === 'string') return timezone;
  if (isBindRef(timezone)) {
    const resolved = resolvePath(timezone.$bind, namespaces, loopItem);
    return typeof resolved === 'string' ? resolved : undefined;
  }
  if (isBindMapRef(timezone)) {
    const resolved = resolveBindMapTimezone(timezone.$bindMap.value, timezone.$bindMap.key, namespaces, loopItem);
    return typeof resolved === 'string' ? resolved : undefined;
  }
  return undefined;
}
export function resolveFormatSpec(format, namespaces, loopItem) {
  if (format.type === 'duration') {
    if (!isAllowedFormatStyle(format.style, DURATION_FORMAT_STYLES)) {
      return undefined;
    }
    return {
      type: 'duration',
      style: format.style
    };
  }
  if (format.type === 'date') {
    if (!isAllowedFormatStyle(format.style, DATE_FORMAT_STYLES)) {
      return undefined;
    }
    return {
      type: 'date',
      style: format.style,
      timezone: resolveTimezone(format.timezone, namespaces, loopItem)
    };
  }
  return undefined;
}